/**
 *
 * @param {PropertyPureProps} value
 * @param {SVGOffsetProps} offset
 * @param {BoundsProps} bounds
 */
const setPointY = (value, offset, bounds) => {
  const computed = offset.computed;
  const height = /** @type {Number} */ (bounds?.get("height"));
  value.set("v_output", `${computed.y - height / 2}px`);
}

export default setPointY;